import { TransitionTypeFinder } from './TransitionTypeFinder';
import { ShortcutHandler } from '../../utils/ShortcutHandler';
import { EventManager } from '../EventManager';
import { TransitionType } from '../../utils/types';

export enum TransitionTypeEvent {
    TypeChanged = 'TypeChanged'
}

export interface ViewFinderWithShortcut {
    viewFinder: TransitionTypeFinder;
    shortcutHandler: ShortcutHandler;
}

export interface TransitionTypeChangedEvent extends Event {
    detail: { transitionType: TransitionType };
}

export class TransitionTypeController {
    private readonly viewFindersWithShortcut: Array<ViewFinderWithShortcut>;
    private lastActiveViewFinder: TransitionTypeFinder;

    constructor(viewFinders: Array<ViewFinderWithShortcut>) {
        this.viewFindersWithShortcut = viewFinders;
        this.lastActiveViewFinder = this.getFirstViewFinder().viewFinder;

        this.registerShortcutHandlers();
        this.resolveViewAndNotify();
    }

    getView(): TransitionType {
        return this.lastActiveViewFinder.get();
    }

    private static notifyViewChanged(transitionType: TransitionType) {
        EventManager.fireCustomEvent(TransitionTypeEvent.TypeChanged, { transitionType });
    }

    private resolveViewAndNotify(viewWithShortcut: ViewFinderWithShortcut): void;
    private resolveViewAndNotify(): void;
    private resolveViewAndNotify(viewWithShortcut?: ViewFinderWithShortcut) {
        if (!viewWithShortcut) {
            viewWithShortcut = this.getFirstViewFinder();
        }
        this.saveFinderViewAndNotify(viewWithShortcut);
    }

    private saveFinderViewAndNotify(viewWithShortcut: ViewFinderWithShortcut) {
        const view = this.getViewAndSaveAsLastActive(viewWithShortcut);
        TransitionTypeController.notifyViewChanged(view);
    }

    private getViewAndSaveAsLastActive(viewWithShortcut: ViewFinderWithShortcut) {
        this.updateViewIfFinderChanged(viewWithShortcut);
        this.lastActiveViewFinder = viewWithShortcut.viewFinder;

        const view = viewWithShortcut.viewFinder.get();
        return view;
    }

    private updateViewIfFinderChanged(viewWithShortcut: ViewFinderWithShortcut) {
        const viewFinderChanged = viewWithShortcut.viewFinder !== this.lastActiveViewFinder;
        const shouldUpdateFinderView = !viewFinderChanged;
        if (!shouldUpdateFinderView) { return; }

        viewWithShortcut.viewFinder.update();
    }

    private getFirstViewFinder() {
        this.validateAtLeastOneViewFinder();
        return this.viewFindersWithShortcut[0];
    }

    private validateAtLeastOneViewFinder() {
        if (this.viewFindersWithShortcut.length < 1) {
            throw new Error('Register at least one view finder before resolving views.');
        }
    }

    private registerShortcutHandlers() {
        for (const viewWithShortcut of this.viewFindersWithShortcut) {
            viewWithShortcut.shortcutHandler.registerOnShortcutExecutedCallback(() => {
                this.resolveViewAndNotify(viewWithShortcut);
            });
        }
    }
}


// WEBPACK FOOTER //
// ./src/webportal/services/transitionType/TransitionTypeController.ts